import React from 'react';
import Chip from '@material-ui/core/Chip';


const FlightRequestChips = ({ variant, flightResources }) => {
    return (
        <>
            {
                flightResources.map((resource, index) =>
                    <span key={index}>
                        <Chip
                            size="small"
                            label={resource.goingFromDestinationName}
                            variant={variant}
                            color="primary"
                        />
                        <Chip
                            size="small"
                            label={resource.goingToDestinationName}
                            variant={variant}
                            color="primary"
                        />
                    </span>
                )
            }
        </>
    )
}

export default FlightRequestChips;